import type { EasingDefinition } from 'motion/react';
import { PropsWithChildren, ReactNode } from 'react';

export type Handler = (() => Promise<void>) | (() => void) | null;

export const variants = { fullWidth: 'fullWidth' } as const;
export const configs = { fullHeight: 'fullHeight' } as const;

export interface WizardProps extends PropsWithChildren {
  startIndex?: number;
  withAnimation?: boolean;
  ease?: EasingDefinition;
  header?: ReactNode;
  showTopIndicators?: boolean;
  showBottomIndicators?: boolean;
  hideIndicatorIndex?: number[];
  hideHeaderIndex?: number[];
  variant?: (typeof variants)[keyof typeof variants];
  config?: (typeof configs)[keyof typeof configs];
}

export type WizardValues = {
  activeStep: number;
  nextStep: () => void;
  prevStep: () => void;
  hasNextStep: boolean;
  hasPrevStep: boolean;
  isFirstStep: boolean;
  isLastStep: boolean;
  goToStep: (stepIndex: number) => void;
  currentStep: number;
  steps: ReactNode[];
};
